import _ from 'lodash'

import { bus } from '../../utils'
import FirmwareUpload from '../FirmwareUpload/FirmwareUpload.vue'
import FirmwareDelete from '../FirmwareDelete/FirmwareDelete.vue'

export default {
  beforeDestroy () {
    bus.$off('get-firmware-list')
  },
  components: { FirmwareUpload, FirmwareDelete },
  computed: {
    componentTitle () {
      return this.$t(`ComponentTitle.${this.$route.name}`)
    },
    defaultSort () {
      return { prop: 'version', order: 'descending' }
    }
  },
  methods: {
    async getFirmwareList () {
      this.loading = true

      const list = await this.$api.getFirmwareList()
      list.data = _.each(list.data, (value, index) => { value.index = index })
      this.firmwareList = list.data
      this.loading = false
    },
    delFirmware (info) {
      bus.$emit('show-delete-firmware', {
        show: true,
        info
      })
    },
    showAddFirmware () {
      bus.$emit('show-add-firmware', true)
    }
  },
  name: 'Firmware',
  created () {
    bus.$on('get-firmware-list', async () => {
      this.getFirmwareList()
    })
  },
  data () {
    return {
      active: 0,
      firmwareList: [],
      loading: true,
      popData: {},
      showDeletePopup: false,
      showModal: false
    }
  },
  mounted () {
    this.getFirmwareList()
  }
}



// WEBPACK FOOTER //
// ./src/components/Firmware/Firmware.js